export const RECIPE_CATEGORIES = ["Breakfast", "Main Course", "Dessert", "Snack", "Drink"] as const;
export type RecipeCategory = typeof RECIPE_CATEGORIES[number];

export const RECIPE_DIFFICULTIES = ["Easy", "Medium", "Hard"] as const;
export type RecipeDifficulty = typeof RECIPE_DIFFICULTIES[number];

export const INGREDIENT_UNITS = ["g", "kg", "ml", "cl", "l", "tsp", "tbsp", "cup", "pcs", "pinch"] as const;
export type IngredientUnit = typeof INGREDIENT_UNITS[number];

export interface Recipe {
  id: string;
  title: string;
  description: string | null;
  image_url: string | null;
  servings: number;
  category: RecipeCategory | string | null;
  cooking_time: number | null; // in minutes
  difficulty: RecipeDifficulty | string | null;
  source_url?: string;
  created_at: string;
}

export interface RecipeIngredient {
  id: string;
  recipe_id: string;
  step_id: string | null;
  name: string;
  quantity: number | null;
  unit: string | null;
  order_index: number;
}

export interface RecipeStep {
  id: string;
  recipe_id: string;
  description: string;
  order_index: number;
  recommendation: string | null;
}

export interface RecipeWithDetails extends Recipe {
  ingredients: RecipeIngredient[];
  steps: RecipeStep[];
}
